import {Usuario} from "./usuario";
import {SituacaoPlano} from "./situacao-plano";
import {Municipio} from "./municipio";
import {PlanoAcaoEstrategica} from "./plano-acao-estrategica";
import {PlanoAvaliacao} from "./plano-avaliacao";
import {PlanoOutraDefinicao} from "./plano-outra-definicao";
import {PlanoObjetivo} from "./plano-objetivo";
import {PlanoDiagnostico} from "./plano-diagnostico";
import {PlanoMeta} from "./plano-meta";

export class Plano {
	public cod_plano: number;
	public cod_usuario: number;
	public cod_municipio: number;
	public cod_situacao_plano: number;
	public num_populacao_estimada: number;
	public num_cnpj: string;
	public num_cep: string;
	public num_telefone: string;
	public dte_atualizacao: string;
	public usuario: Usuario;
	public municipio: Municipio;
	public situacao_plano: SituacaoPlano;
	public objetivos: Array<PlanoObjetivo>;
	public metas: Array<PlanoMeta>;
	public acoes_estrategicas: Array<PlanoAcaoEstrategica>;
	public avaliacoes: Array<PlanoAvaliacao>;
	public outras_definicoes: Array<PlanoOutraDefinicao>;
	public diagnosticos: Array<PlanoDiagnostico>;

	public pode_preencher: boolean = true;

}
